import common from '@/components/sheets/import/impl/common'

function getNumber (v) {
  if (v === undefined) {
    return undefined
  }

  if (v === null || v === '') {
    return null
  }

  return v
}

function createLock (i, p, prefix) {
  return {
    lock: common.getValue(
      p[`${prefix}Lock${i}`], [1, 2, 3, 4, 5, 6, 7, 9]
    ),
    cap: common.getValue(
      p[`${prefix}cap${i}`], [1, 2, 9]
    )
  }
}

function createInfection (type, prefix, p) {
  return {
    infection: getNumber(type),
    origin: common.getValue(p[`${prefix}Origin`], [1, 2, 3, 4, 5, 9]),
    date: common.newDate(p[`${prefix}Episod`]),
    microOrganisms: common.getMicroOrganisms(p, prefix, false),
    antibio: common.getValue(p[`${prefix}Antibio`], [1, 2, 9]),
    diagDate: common.newDate(p[`${prefix}DiagDate`]),
    covidStatus: common.getValue(p[`${prefix}Covid`], [1, 2, 3, 9])
  }
}

function createInfections (n, p) {
  const result = []
  for (let i = 1; i !== 4; ++i) {
    const infection = p[`site${n}infection${i}`]
    if (infection !== null && (infection === 1 || infection === 2)) {
      const inf = createInfection(infection, `site${n}inf${i}`, p)
      if (inf != null) {
        result.push(inf)
      }
    }
  }
  return result
}

function createCatheter (i, p) {
  const accessSite = p[`accessSite${i}`]
  if (accessSite == null || accessSite === '') {
    return null
  }
  return {
    accessSite_v2: accessSite,
    firstUse: common.newDate(p[`firstUse${i}`]),
    uses: getNumber(p[`uses${i}`]),
    incidents: getNumber(p[`incidents${i}`]),
    unrelatedManip: getNumber(p[`unrelatedManip${i}`]),
    ablated: common.getValue(p[`ablated${i}`], [1, 2, 9]),
    ablation: common.newDate(p[`ablation${i}`]),
    useEnded: common.getValue(p[`useEnded${i}`], [1, 2, 3, 4, 9]),
    useEnding: common.newDate(p[`useEnding${i}`]),
    installReason: common.getValue(p[`installReason${i}`], [1, 2, 3, 4, 9]),
    tunneled: common.getValue(p[`tunneled${i}`], [1, 2, 9]),
    installSite: common.getValue(p[`installSite${i}`], [1, 2, 3, 4, 9]),
    siteChanges: common.getValue(p[`siteChanges${i}`], [1, 2, 9]),
    antibiopr: common.getValue(p[`antibiopr${i}`], [1, 2, 9]),
    installLock: createLock(i, p, 'install'),
    disconnectLock: createLock(i, p, 'disconnect'),
    infections: createInfections(i, p)
  }
}

function createCatheters (p) {
  const result = []
  for (let i = 1; i !== 5; ++i) {
    const kt = createCatheter(i, p)
    if (kt != null) {
      result.push(kt)
    }
  }
  return result
}

function createBacteremias (p) {
  return common.createList(p, common.createBacteremia(true, true), 3, 'bact')
}

function createSheet (year, p) {
  const sheet = {
    sheetNumber: p.sheetNumber,
    uf: p.uf != null && p.uf !== '' ? p.uf.toString() : null,
    unitType: common.getUnitTypeCode(year, p.unitType),
    birthdate: common.newDate(p.birthdate),
    sex: common.getValue(p.sex, [1, 2, 3, 9]),
    firstSubstn: common.newDate(p.firstSubstn),
    hemodiafiltr: common.getValue(p.hemodiafiltr, [1, 2, 9]),
    entry: common.newDate(p.entry),
    treatedDiab: common.getValue(p.treatedDiab, [1, 2, 9]),
    immuno: common.getValue(p.immuno, [1, 2, 9]),
    hygiene: common.getValue(p.hygiene, [1, 2, 3, 4]),
    previousInfect: common.getValue(p.previousInfect, [1, 2, 9]),
    previousBact: common.getValue(p.previousBact, [1, 2, 9]),
    toxico: common.getValue(p.toxico, [1, 2, 9]),
    vih: common.getValue(p.vih, [1, 2, 9]),
    vhc: common.getValue(p.vhc, [1, 2, 9]),
    height: getNumber(p.height),
    weight: getNumber(p.weight),
    ferritinaemia: getNumber(p.ferritinaemia),
    saturation: getNumber(p.saturation),
    hemoglobin: getNumber(p.hemoglobin),
    albumin: getNumber(p.albumin),
    creatinine: getNumber(p.creatinine),
    dialNumber: getNumber(p.dialNumber),
    cardioVascPb: common.getValue(p.cardioVascPb, [1, 2, 9]),
    surgery: common.getValue(p.surgery, [1, 2, 9]),
    transfusions: getNumber(p.transfusions),
    exit: common.newDate(p.exit),
    exitReason: common.getValue(p.exitReason, [1, 2, 3, 4]),
    covidStatus: common.getValue(p.covidStatus, [1, 2, 3, 9]),
    catheters: createCatheters(p),
    bacteremias: createBacteremias(p)
  }

  common.checkMissingColumns(sheet)

  return sheet
}

export default {
  createSheet: createSheet
}
